import { render } from "./ValidationDocumentList.vue?vue&type=template&id=6a303911&scoped=true&ts=true"
import script from "./ValidationDocumentList.vue?vue&type=script&lang=ts"
export * from "./ValidationDocumentList.vue?vue&type=script&lang=ts"

import "./ValidationDocumentList.vue?vue&type=style&index=0&id=6a303911&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a303911"]])

export default __exports__